<template>
<el-container class="service-order-config-wrap">
   <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <publicExpandSearch padBottom='0px' :searchList='searchList' ref='expSearch' v-on:getSearchObj='getSearchObj'></publicExpandSearch>  
      <el-tabs v-model="activeStatus" @tab-click="handleClick">
        <el-tab-pane label="全部" name="2"></el-tab-pane>
        <el-tab-pane label="待处理" name="0"></el-tab-pane>
        <el-tab-pane label="已完成" name="1"></el-tab-pane>
      </el-tabs>
    </div> 
  <el-main style="padding: 0;">
    <div class="table-wrap">
      <el-table
        :data="unnormalTableData"
        :header-cell-style="{textAlign: 'center',color: '#333333',fontSize: '14px', fontWeight: 'bold',backgroundColor: '#FAFAFA'}">
         <el-table-column prop="createType" label="类型" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.createType === 1?'医护':'患者'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="下单人" align="center" width="150"></el-table-column>
        <el-table-column prop="patientName" label="被服务人" width="150" align="center">
          <template slot-scope="scope">{{!scope.row.logOff ? scope.row.patientName:scope.row.patientName+'(已注销)'}}</template>
        </el-table-column>
        <el-table-column prop="patientPhone" label="联系方式" width="150" align="center"></el-table-column>
        <el-table-column prop="orderTime" label="服务下单时间" width="160" align="center"></el-table-column>
        <el-table-column prop="nursingDefinitionName" label="医护服务名称" width="150" align="center"></el-table-column>
        <el-table-column prop="doctorName" label="接单护士" width="150" align="center"></el-table-column>
        <el-table-column prop="doctorPhone" label="护士联系方式" width="150" align="center"></el-table-column>
        <el-table-column prop="matronName" label="上级护士长" width="150" align="center"></el-table-column>
        <el-table-column prop="matronPhone" label="护士长联系方式" width="150" align="center"></el-table-column>
        <el-table-column prop="receiveTime" label="医护接单时间" width="165" align="center"></el-table-column>
        <el-table-column prop="createTime" label="异常情况提交时间" width="165" align="center"></el-table-column>
        <el-table-column prop="exceDesc" label="异常情况" width="150" align="center" show-overflow-tooltip>
            <!-- <template slot-scope="scope">
                <el-tooltip placement="top">
                    <div slot="content">{{ scope.row.exceDesc }}</div>
                    <el-button type="text">这是一条异常说明</el-button>
                </el-tooltip>
            </template> -->
        </el-table-column>
        <el-table-column prop="exceStatus" label="状态" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.exceResponse === 0?'待处理':'已完成'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="200">
            <template slot-scope="scope">
                <el-button v-if="scope.row.exceResponse === 0" type="text" size="small" @click="clickToHandle(scope.row)">已处理</el-button>
                <el-button v-if="scope.row.exceResponse === 1" type="text" size="small" disabled>已处理</el-button>
            </template>
        </el-table-column>
    </el-table>
  </div>  
  <el-pagination
    style="text-align:right;background-color:#fff;padding-top:30px;padding-bottom:20px"
    background
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page.sync="searchParams.current"
    :page-size="searchParams.size"
    layout="total, sizes, prev, pager, next, jumper"
    :total="total">
  </el-pagination>
  </el-main>
</el-container>
</template>
<script>
import {queryUnnormalList,handleUnnormal} from "@/api/serviceOrder"

export default {
  components: {},
  data() {
    return {
      breadList: [{ name: "医护上门管理" }, { name: "异常情况处理" }],
      searchList: [
          {
              label: "被服务人姓名",
              paramName: "patientName",
              inputType: "input"
          }
      ],
      searchParams:{
        current:1,
        size:10,
        exceResponse:''
      }, 
      activeStatus: "2", 
      total:0,
      unnormalTableData:[],
    }
  },
  async created() {
    this.getTableList(1)
  },
  mounted() {},
  methods: {
    getSearchObj(obj) {
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams };  
      this.getTableList()
		}, 
    handleSizeChange(val) {
      this.searchParams.size = val
      this.getTableList()
    },
    handleCurrentChange(val) {
      this.searchParams.current = val
      this.getTableList()
    },
    async clickToHandle(row) {
      this.$confirm('请确认是否已处理该异常情况', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        customClass: 'message-confirm'
      }).then(async () => {
        let res = await handleUnnormal({
          id: row.id,
          exceStatus: row.exceStatus
        })
        if (res.code === 0) {
          this.$message.success('处理成功')
          this.getTableList()
        }
      })
    },
    handleClick() {
      this.searchParams.current = 1
      this.searchParams.size = 10
      this.getTableList()
    },
    async getTableList() { 
      if (this.activeStatus === '2') {
        this.searchParams.exceResponse = ''
      } else {
        this.searchParams.exceResponse = this.activeStatus
      }
      let res = await queryUnnormalList(this.searchParams)
      if (res.code === 0) {
        this.unnormalTableData = res.data.records
        this.total = res.data.total
      }
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.el-tabs__header {
  margin: 0;
}
/deep/.el-tabs__nav-wrap::after {
  background-color: #FFFFFF;
}
.service-order-config-wrap {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  /deep/.el-table__header th {
    padding: 0;
    height: 54px;
  } 
  .el-button--text {
    color: #1A7BFC;
  }
}
.el-table td, .el-table th {
  padding: 10px 0;
}
.el-button.is-disabled.el-button--text {
  color: #999999;
}
.table-wrap {
  padding: 15px 5px;
  padding-bottom: 0px;
  background-color: #FFFFFF;
}
</style>
